/**
 * Lists in plain words (one profile's talent pages and notices), PURE and shared, so the server's notices and the
 * client's pages say a list the same way.
 */
/** Names as a sentence list: "A", "A and B", "A, B and C" (blanks dropped). */
export function joinNames(names) {
    const list = names.filter(Boolean);
    if (list.length < 2)
        return list[0] ?? '';
    return `${list.slice(0, -1).join(', ')} and ${list.at(-1)}`;
}
/**
 * Up to `max` labels, then "and N more" ("Height", "Height and Weight", "Height, Weight, Hair and 2 more"); duplicates and
 * blanks dropped; `none` when there is no label at all.
 */
export function labelList(labels, max = 3, none = 'a detail') {
    const unique = [...new Set(labels.map((l) => l.trim()).filter(Boolean))];
    if (!unique.length)
        return none;
    const shown = unique.slice(0, max);
    const more = unique.length - shown.length;
    return more > 0 ? `${shown.join(', ')} and ${more} more` : joinNames(shown);
}
//# sourceMappingURL=text.js.map